import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class CaptureMessageRecord
 * @augments BaseMessageRecord
 */
class CaptureMessageRecord extends BaseMessageRecord({
  type: "capture",

  /**
   * @memberof CaptureMessageRecord#
   */
  alwaysAsk: false,
  chatterResponseOptional: false,
  captureKey: "",
  captureLead: "",
  captureType: "string",
  scopeChanged: false
}) {}

/**
 * Validation
 */

/**
 * @param {CaptureMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
CaptureMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!message.captureLead) {
    invalidFields.add("captureLead");
  }

  const isCaptureKeyValid = message.captureKey && message.captureKey.length <= 100;

  if (!isCaptureKeyValid) {
    invalidFields.add("captureKey");
  }

  return Immutable.List(invalidFields);
};

export default CaptureMessageRecord;
